import React, { useEffect, useState, useMemo } from 'react'
import PropTypes from 'prop-types'
import { InView } from 'react-intersection-observer'
import loadable from '@loadable/component'

import { reportCitrusBanner } from '../../actions/executeBeacon'
import { transformCarouselData } from './helper'

const CMS = loadable.lib(() => import(/* webpackChunkName: "cms-components" */ '@sainsburys-tech/bolt-cms-components'))

const CarouselBanner = ({ data, placement, categoryName }) => {
  const [currentAdId, setCurrentAdId] = useState(null)
  const [impressionsSent, setImpressionsSent] = useState([])

  const carouselData = useMemo(() => transformCarouselData(data, placement, categoryName), [
    data,
    categoryName,
    placement
  ])

  const handleImpressions = slidePosition => {
    const currentSlideAdId = slidePosition && data[slidePosition - 1]?.citrusAdId
    setCurrentAdId(currentSlideAdId)
    if (!impressionsSent?.includes(currentSlideAdId)) {
      reportCitrusBanner(currentSlideAdId, 'impression')
      setImpressionsSent([...impressionsSent, currentSlideAdId])
    }
  }

  const handleSliderInView = citrusAdId => {
    reportCitrusBanner(citrusAdId, 'impression')
    setImpressionsSent([...impressionsSent, citrusAdId])
  }

  const handleClick = el => {
    const elClicked = el.target.getAttribute('data-test')
    const isBanner = elClicked === 'm020-image' || false
    if (isBanner) reportCitrusBanner(currentAdId, 'click')
  }

  useEffect(() => {
    setCurrentAdId(data[0]?.citrusAdId)
  }, [])

  return (
    <>
      <CMS>
        {({ components }) => {
          const { UG005 } = components

          return (
            <div
              role='button'
              tabIndex='0'
              onClick={el => handleClick(el)}
              onKeyPress={event => {
                if (event.key === 'Enter' || event.key === ' ') {
                  handleClick(event)
                }
              }}
              aria-label='Clickable element'>
              <InView triggerOnce onChange={view => view && data && handleSliderInView(data[0]?.citrusAdId)}>
                <UG005 onSlideChange={value => handleImpressions(value)} included={carouselData} />
              </InView>
            </div>
          )
        }}
      </CMS>
    </>
  )
}

CarouselBanner.propTypes = {
  placement: PropTypes.string.isRequired,
  categoryName: PropTypes.string.isRequired,
  data: PropTypes.instanceOf(
    Array(
      PropTypes.shape({
        altText: PropTypes.string,
        desc: PropTypes.string,
        desktopImage: PropTypes.string,
        linkTarget: PropTypes.string,
        linkTitle: PropTypes.string,
        linkUrl: PropTypes.string,
        mobileImage: PropTypes.string,
        tabletImage: PropTypes.string,
        type: PropTypes.string
      })
    )
  ).isRequired
}

export default CarouselBanner
